<template>
  <div
    class="boss-message-header-layout"
    data-test="date-area"
  >
    <div
      class="boss-layout-block boss-message-when"
      data-test="date"
    >
      {{ date | formatDate }}
      <template v-if="isRead!=null">
        <span
          v-if="isRead"
          data-test="read"
          class="boss-message-status-label boss-message-status-label-read"
        >既読</span>
        <span
          v-else
          data-test="no-read"
          class="boss-message-status-label"
        >未読</span>
      </template>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'

export default {
  filters: {
    formatDate (val, defaultLabel = '') {
      return val ? dayjs(val).format('YYYY/MM/DD(ddd) HH:mm') : defaultLabel
    }
  },
  props: {
    date: {
      type: String,
      default: ''
    },
    isRead: {
      type: Boolean,
      default: null
    }
  }
}
</script>
